var map = {
	"./Freelance": 23,
	"./Freelance.jsx": 23,
	"./Iframe": 17,
	"./Iframe.jsx": 17,
	"./Projects": 24,
	"./Projects.jsx": 24,
	"./Timeline": 20,
	"./Timeline.jsx": 20,
	"./TimelineItem": 11,
	"./TimelineItem.jsx": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;